export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/BackgroundTrainer.7ce8b9bb.worker.js");
}
